import React from 'react';
import TruckLeftIcon from '../assets/truck-left.svg';
import TruckRightIcon from '../assets/truck-right.svg';
import styles from './bouncing-truck.module.scss';

interface IDirection {
  direction: string;
}

const BouncingTruck: React.FC<IDirection>  = (props) => {
  return (
    <div
      className={styles.bouncingTruck}
      style={{backgroundImage: `url(${props.direction === 'right' ? TruckRightIcon : TruckLeftIcon})`}}
    />
  );
};

export default BouncingTruck;
